import React, { useContext } from "react";

import {
  Tabs as ChakraTabs,
  TabList,
  TabPanels,
  TabPanel,
  Box,
} from "@chakra-ui/react";

import FiltroReporte from "./FiltroReporte";

import TabButton from "../Tabs/TabButton";
import { UtilDataContextProvider } from "../../Context/utilDataContext";
import Results from "./Results";
import Totales from "./Totales";
import ButtonGroup from "./ButtonGruop";
import { SEARCH_ADMIN } from "../../Constants/buscarDato";
import usePermisos from "../../Hooks/usePermisos";
const Reporte = () => {
  //
  const { hasPermiso, getDisplayPermisont } = usePermisos(SEARCH_ADMIN);
  const endOfPageRef = React.useRef(null);
  const topOfPageRef = React.useRef(null);
  //

  if (!hasPermiso(SEARCH_ADMIN)) return getDisplayPermisont(SEARCH_ADMIN);

  return (
    <div ref={topOfPageRef}>
      <ChakraTabs variant="enclosed" colorScheme="blue">
        <TabList __css={{ borderBottom: "5px solid #1C6EA4" }}>
          <TabButton title="Listado ventas" />
        </TabList>
        <Box height="5px" bg="blue.500" mt={0.5} />

        <TabPanels>
          <TabPanel bg="#ECF2F7" shadow="lg" borderRadius="lg" borderTop="none">
            <UtilDataContextProvider>
              <FiltroReporte />
            </UtilDataContextProvider>
          </TabPanel>
        </TabPanels>
      </ChakraTabs>

      <ButtonGroup ref={endOfPageRef} />
      <Results />
      <Totales ref={{ endOfPageRef, topOfPageRef }} />
    </div>
  );
};

export default Reporte;
